/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdInputProps } from './type';

export const inputDefaultProps: TdInputProps = {
  align: 'left',
  allowInputOverMax: false,
  autoWidth: false,
  autocomplete: undefined,
  autofocus: false,
  borderless: false,
  clearable: false,
  placeholder: undefined,
  readonly: false,
  showClearIconOnEmpty: false,
  showLimitNumber: false,
  size: 'medium',
  status: undefined,
  type: 'text',
  defaultValue: '',
};
